// side effect: fetch llmf data
import {fetchLLMF} from '../slices/productDataSlice';
import {selectLLMFUrl} from '../selectors';

export const llmfMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'decisions/decision/fulfilled' || action.type === 'decisions/decisionsLoading/fulfilled') {
        if (store.getState().session.sessionId !== null) {
            // after decision(s), get the new llmf file
            if (selectLLMFUrl(store.getState()) !== '-' && selectLLMFUrl(store.getState()) !== null) {
                store.dispatch(fetchLLMF({
                    url: selectLLMFUrl(store.getState())
                }));
            }
        }
    }
    return result;
};
